import styled from "styled-components";
import ExternalLink from "../ExternalLink";
import Link from "../Link";

export const Menu = styled.div`
  width: 100vw;
  background-color: ${(props) => props.theme.background};
  z-index: 10;
  position: relative;
`;

export const NavLinks = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start;
  border-top: 1px solid ${(props) => props.theme.sidebarBorderHeader};
  padding: 24px 0px 16px;
  position: fixed;
  background-color: #1B1E29;
  top:80px;
  z-index: 500;
`;

export const NavButton = styled.button`
  display: flex;
  color: #FFF;
  font-size: 24px;
  background: none;
  border: none;
`;

export const Options = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100vw;
  min-height: 100vh;
  cursor: pointer;
  margin-top: 70px;

  background-color: ${(props) =>
    props.background === "primary-darken"
      ? props.theme.optionsHeaderPrimaryDarken
      : props.theme.optionsHeaderPrimary};

  color: #fff;

  &:after {
    content: " ";
    position: absolute;
    top: -10px;
    border-top: none;
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
    border-bottom: 10px solid ${(props) => props.theme.optionsHeaderPrimary};
    right: calc(${(props) => props.offset});
  }
`;

export const CustomLink = styled(Link)`
  font-size: 22px;
  display: block;
  color: ${(props) => props.theme.menuLabelColor};
  margin: 24px 0px 21px 0;
  letter-spacing: -0.5px;
`;

export const CustomExternalLink = styled(ExternalLink)`
  font-size: 22px;
  display: block;
  color: ${(props) => props.theme.menuLabelColor};
  margin: 20px 0px;
  letter-spacing: -0.3px;
`;

export const LinkGroup = styled.div`
  margin: 0px 30px;
`;

export const OptionsGroup = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 100%;
  background-color: ${(props) =>
    props.background === "primary-darken"
      ? props.theme.optionsHeaderPrimaryDarken
      : props.theme.optionsHeaderPrimary};
`;

export const HighlightSection = styled.div`
  color: ${(props) => props.theme.menuLabelColor};
  display: flex;
  flex-direction: column;

  &:hover {
    color: ${(props) => props.theme.menuLabelColor};
  }

  margin-bottom: 40px;
  margin-top: 10px;
`;

export const HighlightSectionDescription = styled.div`
  margin-top: 15px;
  margin-left: 30px;

  span {
    display: block;
    margin-bottom: 10px;
    svg {
      margin-left: 5px;
    }
  }

  p {
    margin-top: 0;
    font-size: 14px;
    font-weight: normal;
    overflow-wrap: break-word;
    margin-right: 30px;
    line-height: 18px;
  }

  a {
    margin-top: 0px;
    margin-bottom: 5px;
  }
`;

export const HighlightSectionIcon = styled.div`
  margin-top: 20px;
  margin-left: 30px;
  width: 90%;
`;

export const DetailedLink = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-top: 0;
  }

  p {
    font-weight: normal;
    font-size: 13px;
    margin-top: -20px;
  }

  div {
    margin-left: 20px;
    white-space: normal;
  }
`;

export const MutableSection = styled.div`
  width: 100%;
  font-weight: normal;
  padding: 30px;
  background: ${(props) => `url(${props.background})`};
  box-shadow: 100px -0px 70px #242732 inset, -0px -100px 70px #242732 inset,
    -0px 70px 70px #242732 inset;
  background-repeat: no-repeat;
  background-size: cover;

  border-left: 1px solid ${(props) => props.theme.borderColor};

  h4 {
    display: block;
    font-size: 28px;
    line-height: 32px;
    margin-top: 25px;
    letter-spacing: -1px;
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    span {
      font-size: 12px;
      line-height: 14px;
      opacity: 66%;
      letter-spacing: 1px;
      color: ${(props) => props.theme.optionsDateAndButtonColor};
    }

    strong {
      display: block;
      margin-top: 50px;
      font-size: 40px;
      line-height: 28px;
    }

    p {
      margin-top: 20%;
      font-weight: 300;
      font-size: 18px;
      line-height: 22px;
    }

    img {
      border-radius: 5px;
      margin-top: 10px;
    }
    }

    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.mobile} {
    p {
      margin-top: 20%;
      font-weight: 300;
      font-size: 13px;
      line-height: 16px;
      margin-bottom: 30px;
    }

    img {
      border-radius: 5px;
      margin-top: 10px;
    }
  }
`;

export const RedirectContainer = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: space-between;

  button {
    display: flex;
    justify-content: space-around ;
    align-items: center;
    width: 200px;
    svg {
      width: 13px;
      height: 13px;
      path {
        fill: #fff;
        stroke: #fff;
      }
    }
    a {
      color: #fff;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      &:hover {
        color: #fff;
      }
    }
  }
`;
export const NumberContainer = styled.div`
  width: 61px;
  height: 40px;

  color: #fff;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;

  background: rgba(0, 0, 0, 0.14);
  border-radius: 100px;

  display: flex;
  justify-content: center;
  align-items: center;
`;
